import { render, staticRenderFns } from "./response.vue?vue&type=template&id=3d6c2642&scoped=true&"
import script from "./response.vue?vue&type=script&lang=js&"
export * from "./response.vue?vue&type=script&lang=js&"
import style0 from "./response.vue?vue&type=style&index=0&id=3d6c2642&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c2642",
  null
  
)

export default component.exports